/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Set the loading state
 *
 * @param {Object} state
 */
const SET_LOADING = state => {
    state.loading = true
    state.error = null
}

/**
 * Reset the loading state
 *
 * @param {Object} state
 */
const RESET_LOADING = state => {
    state.loading = false
}

/**
 * Handle the data response
 *
 * @param {Object} state
 * @param {Object} payload
 */
const GET_DATA_SUCCESS = (state, payload) => {
    state.data = payload.data
    state.meta = payload.meta
}

/**
 * Handle the data failure
 *
 * @param {Object} state
 * @param {Object} error
 */
const GET_DATA_FAILURE = (state, error) => {
    state.error = error
}

export default {
    RESET_STATE,
    SET_LOADING,
    RESET_LOADING,
    GET_DATA_SUCCESS,
    GET_DATA_FAILURE
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/exit-assumptions/mutations.js